import { useState } from "react";

export default function BookForm({ onSubmit, initial = {} }) {
  const [title, setTitle] = useState(initial.title || "");
  const [author, setAuthor] = useState(initial.author || "");
  const [status, setStatus] = useState(initial.status || "tbr");
  const [rating, setRating] = useState(initial.rating || 0);
  const [genres, setGenres] = useState((initial.genres || []).join(", "));

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit?.({
      title,
      author,
      status,
      rating: Number(rating),
      genres: genres
        .split(",")
        .map((g) => g.trim())
        .filter(Boolean),
    });
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "#fff",
        border: "1px solid #cbd5e1",
        borderRadius: 16,
        padding: 24,
        maxWidth: 480,
      }}
    >
      <h2 style={{ marginTop: 0, marginBottom: 16, fontSize: 18 }}>
        {initial.id ? "Edit Book" : "Add Book"}
      </h2>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", fontSize: 14, fontWeight: 500 }}>
          Title
        </label>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={{
            width: "100%",
            border: "1px solid #94a3b8",
            borderRadius: 8,
            padding: "8px 10px",
          }}
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", fontSize: 14, fontWeight: 500 }}>
          Author
        </label>
        <input
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          style={{
            width: "100%",
            border: "1px solid #94a3b8",
            borderRadius: 8,
            padding: "8px 10px",
          }}
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", fontSize: 14, fontWeight: 500 }}>
          Status
        </label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={{
            width: "100%",
            border: "1px solid #94a3b8",
            borderRadius: 8,
            padding: "8px 10px",
          }}
        >
          <option value="tbr">To Read</option>
          <option value="reading">Reading</option>
          <option value="finished">Finished</option>
        </select>
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", fontSize: 14, fontWeight: 500 }}>
          Rating (0-5)
        </label>
        <input
          type="number"
          min={0}
          max={5}
          value={rating}
          onChange={(e) => setRating(e.target.value)}
          style={{
            width: "100%",
            border: "1px solid #94a3b8",
            borderRadius: 8,
            padding: "8px 10px",
          }}
        />
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ display: "block", fontSize: 14, fontWeight: 500 }}>
          Genres (comma separated)
        </label>
        <input
          value={genres}
          onChange={(e) => setGenres(e.target.value)}
          placeholder="self-improvement, mindset"
          style={{
            width: "100%",
            border: "1px solid #94a3b8",
            borderRadius: 8,
            padding: "8px 10px",
          }}
        />
      </div>

      <button
        type="submit"
        style={{
          background: "#0ea5e9",
          color: "white",
          fontWeight: 600,
          padding: "10px 14px",
          border: "none",
          borderRadius: 10,
          cursor: "pointer",
          width: "100%",
        }}
      >
        {initial.id ? "Save Changes" : "Add Book"}
      </button>
    </form>
  );
}
